<template>
  <div
    role="dialog"
    class="flex flex-col overflow-hidden bg-white rounded-lg dark:bg-gray-700 shadow-200 dark:border dark:border-gray-900"
  >
    <slot />
  </div>
</template>
